module.exports = __webpack_public_path__ + "img/game_scene.348362e9.png";